import { render } from "./ToNav.vue?vue&type=template&id=194ba5fa&scoped=true&ts=true"
import script from "./ToNav.vue?vue&type=script&lang=ts"
export * from "./ToNav.vue?vue&type=script&lang=ts"

import "./ToNav.vue?vue&type=style&index=0&id=194ba5fa&scoped=true&lang=css"

import exportComponent from "C:\\vue项目\\newbdb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-194ba5fa"]])

export default __exports__